export default __webpack_public_path__ + "static/media/opensea-logo-white.d65406cd.svg";